/**
 * Arma un menú de navegación de Fuse a partir de una tabla de texto: una línea por
 * entrada con `tipo id | título | ícono | url` (ícono y url opcionales) y la jerarquía
 * por tabulaciones. Los grupos y colapsables reciben `children` aunque no tengan hijos.
 *
 * @example
 * parseNavigation(`
 * group consultas | Consultas | search
 * 	item facturas | Facturas | receipt | /consultas/facturas
 * `)
 */
const parseNavigation = table => {
	const root = { children: [] };
	const stack = [{ depth: -1, node: root }];

	for (const line of table.split('\n')) {
		if (line.trim()) {
			const depth = line.search(/\S/);
			const [head, title, icon, url] = line.split('|').map(part => part.trim());
			const [type, id] = head.split(/\s+/);

			const entry = { id, title, type };
			if (icon) entry.icon = icon;
			if (url) entry.url = url;
			if (type !== 'item') entry.children = [];

			while (stack.at(-1).depth >= depth) stack.pop();
			stack.at(-1).node.children.push(entry);
			stack.push({ depth, node: entry });
		}
	}

	return root.children;
};

export default parseNavigation;
